Shopware.Component.register('riccardo-loyalty-list', () => import('./page/riccardo-loyalty-list'));
Shopware.Component.register('riccardo-loyalty-detail', () => import('./page/riccardo-loyalty-detail'));

Shopware.Module.register('riccardo-loyalty', {
    type: 'plugin',
    name: 'riccardo-loyalty',
    title: 'Kundenkarten',
    description: 'Riccardo Kundenkarte',
    color: '#E30613',
    icon: 'regular-credit-card',
    entity: 'riccardo_loyalty_account',

    routes: {
        list: { component: 'riccardo-loyalty-list', path: 'list' },
        detail: { component: 'riccardo-loyalty-detail', path: 'detail/:id', meta: { parentPath: 'riccardo.loyalty.list' }, props: { default: (route) => ({ accountId: route.params.id }) } },
    },

    navigation: [{
        id: 'riccardo-loyalty',
        label: 'Kundenkarten',
        color: '#E30613',
        path: 'riccardo.loyalty.list',
        icon: 'regular-credit-card',
        parent: 'sw-customer',
        position: 50,
    }],
});
